import clsx from 'clsx';
import React from 'react';

import CheckBoxField from '@components/Form/CheckBoxField';

import styles from './styles.module.scss';

interface AnonymoustPostBlockProps {
  isAnonymous: boolean;
  justify?: 'left' | 'center' | 'right';
}

const AnonymousPostBlock = ({ isAnonymous, justify = 'center' }: AnonymoustPostBlockProps) => {
  return (
    <>
      <div
        className={clsx(styles.anonymousCheckbox, {
          [styles.anonymousCheckboxLeft]: justify === 'left',
          [styles.anonymousCheckboxCenter]: justify === 'center',
          [styles.anonymousCheckboxRight]: justify === 'right',
        })}
      >
        <CheckBoxField
          name="is_anonymous"
          className="checkbox-input !my-8"
          label="Post anonymously?"
        />
      </div>
      <div
        className={clsx(styles.anonymousHelperText, {
          [styles.anonymousHelperTextActive]: isAnonymous,
          [styles.anonymousCheckboxLeft]: justify === 'left',
          [styles.anonymousCheckboxCenter]: justify === 'center',
          [styles.anonymousCheckboxRight]: justify === 'right',
        })}
      >
        Anonymous posts cannot be edited or deleted
      </div>
    </>
  );
};

export default AnonymousPostBlock;
